export type Level = "normal" | "easy" | "hard" | "killer";

export function isValidLevel(level?: string): level is Level {
  if (!level) return false;
  return ["normal", "easy", "hard", "killer"].includes(level as Level);
}
